import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { homePathForUser } from "@/lib/roleRouting";
import { isFinanceOwner, isFinanceOrLegal } from "@/lib/constants";

/**
 * RoleGuard — wrap a route to restrict access by role.
 *   <RoleGuard allow={["admin","management","accounting"]}><Payments /></RoleGuard>
 *
 * ownersOnly=true → sadece FINANCE_OWNER_EMAILS whitelist'i.
 * ownersOrLegal=true → finance owner VEYA hukuk müşaviri erişebilir.
 */
export default function RoleGuard({ allow, ownersOnly, ownersOrLegal, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (ownersOrLegal) {
    if (!isFinanceOrLegal(user)) {
      return <Navigate to={homePathForUser(user)} replace />;
    }
    return children;
  }
  if (ownersOnly) {
    if (!isFinanceOwner(user)) {
      return <Navigate to={homePathForUser(user)} replace />;
    }
    return children;
  }
  // Legal rolü diğer modüllere erişemez (yalnızca /finance/compliance)
  if (user.role === "legal") {
    if (allow && allow.includes("legal")) return children;
    return <Navigate to="/finance/compliance" replace />;
  }
  // Mühendis rolü diğer modüllere erişemez (yalnızca /tse-tuv)
  if (user.role === "engineer") {
    if (allow && allow.includes("engineer")) return children;
    return <Navigate to="/tse-tuv" replace />;
  }
  // Venni firma temsilcisi diğer modüllere erişemez (yalnızca /venni-portal)
  if (user.role === "venni_supplier") {
    if (allow && allow.includes("venni_supplier")) return children;
    return <Navigate to="/venni-portal" replace />;
  }
  const allowed = new Set([...(allow || []), "admin"]);
  if (!allowed.has(user.role)) {
    return <Navigate to={homePathForUser(user)} replace />;
  }
  return children;
}
